<template lang="pug">
div.body-cateques
  div.modal-header
    span.cateques-modal-title SỬA DANH MỤC CÂU HỎI
    span.cateques-modal-btn-close.material-icons(@click="$emit('close')") close
  div.modal-body.cateques-custom-body
    p.cateques-content Tên danh mục
    .row
      .col-md-12
        .alert.alert-danger(v-if='error') {{error}}
    .row
      .col-md-12.form-group.cateques-email(:class="error && arrError || ''")
        input#name.form-control(type="text" maxlength=125 name="name" placeholder="Nhập" required autofocus v-model="content" @keyup="onChange")
  div.modal-footer.cateques-custom-footer
    div.row
      div.col-md-6.col-12
        div.text-right
          a.cateques-btn-continue.btn(@click='validateEdit()') Lưu thay đổi
      div.col-md-6.col-12
        div.text-left
          a.cateques-btn-back.btn(@click="$emit('close')") Hủy yêu cầu
</template>
<script>
export default {
  props: {
    saveFunction: Function,
    id: Number,
    name: String
  },
  data () {
    return {
      content: this.name,
      error: null,
      arrError: ['is-empty has-error is-focused']
    }
  },
  methods: {
    validateEdit() {
      if (this.content.trim().length > 0) {
        this.saveFunction({ name: this.content, id: this.id })
        this.$nextTick(() => {
          this.$emit('close')
        })
      } else {
        this.error = 'Vui lòng nhập tên danh mục câu hỏi.'
      }
    },
    onChange(e) {
      if (this.content.trim().length > 0) {
        this.error = ''
        if (e.keyCode === 13) this.validateEdit()
      }
    }
  }
}
</script>
<style lang="scss">
:root {
  // Color 
  --color-background-button: #FFD311;
}
.body-cateques {
  margin-left: 20px;
  margin-right: 20px;
  background-color: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 10px;
  font-family: 'adobe-clean', sans-serif;
  .cateques-modal-title {
    float: left;
    font-size: 17px;
  }
  .cateques-modal-btn-close {
    float: right;
    &:hover {
      cursor: pointer;
    }
  }
  .cateques-body-title {
    color: var(--color-type-selected);
    margin-bottom: 0;
    padding-bottom: 3px;
  }
  .cateques-content {
    margin-bottom: 15px;
    font-size: 15px;
  }
  .cateques-email {
    margin-top: 0px; 
    margin-bottom: 0px;
    padding-bottom: 10px;
  }
  .cateques-btn-continue {
    background: var(--color-background-button);
    color:black;
    text-transform: none;
    font-size: 13px;
    // font: 14px/17px Proxima Nova;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    margin-top: 0 !important;
    margin-bottom: 20px;
  }
  .cateques-btn-back {
    background: white;
    color: black;
    text-transform: none;
    font-size: 13px;
    // font: 14px/17px Proxima Nova;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    margin-top: 0 !important;
  }
  .cateques-custom-footer {
    padding: 0;
    border: 0;
  }
  .cateques-custom-body {
    padding-bottom: 0;
  }

// cellphones
@media (max-width: 414px) {
  .cateques-btn-continue {
    float: left;
    margin-left: 40px;
    width: 115px;
    padding: 12px;
    margin-top: 0px;
  }
  .cateques-btn-back {
    float: right;
    margin-right: 40px;
    width: 115px;
    margin-top: 0px;
    padding: 12px 20px;
  }
}
}
</style>



// WEBPACK FOOTER //
// popupEdit.vue?66df39f1